import { render, staticRenderFns } from "./criteria-basic-interests.vue?vue&type=template&id=198b60b4&scoped=true&"
import script from "./criteria-basic-interests.vue?vue&type=script&lang=ts&"
export * from "./criteria-basic-interests.vue?vue&type=script&lang=ts&"
import style0 from "./criteria-basic-interests.vue?vue&type=style&index=0&id=198b60b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b60b4",
  null
  
)

export default component.exports